import React from "react";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import NewInvitationForm from "../../components/NewInvitationForm";
import { useNavigate } from "react-router-dom";

const MobileNewAccessKey = () => {
  const navigate = useNavigate();
  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      <div className="mb-4">
        <MobileSecViewsHeader
          title={"Nueva Invitación"}
          route={"/access-keys"}
        />
      </div>
      <NewInvitationForm
        extraFunc={() => navigate("/access-keys")}
        showContacts={false}
        setShowContacts={() => {}}
        openView={false}
        isMobile={true}
      />
    </div>
  );
};

export default MobileNewAccessKey;
